import { useState } from 'react'

function useOpenCloseHandler() {
  const [open, setOpen] = useState<boolean>(false)

  function handleOpen() {
    setOpen((prev) => !prev)
  }

  function handleClose() {
    setOpen(false)
  }

  return { open, handleOpen, handleClose }
}

export default useOpenCloseHandler
